<template>
  <fieldset :disabled="disabled">
    <b-form-group>
      <b-form-radio-group v-model="section.classification" stacked>
        <b-form-radio value="Professional">
          We wish to be classified as a per se 'Professional Client' or an elective 'Professional Client'
        </b-form-radio>
        <b-form-radio value="Retail">
          We request to be re-classified as a Retail Client instead of a Professional Client
          (increasing the level of protection; note: we may not be able to do business with you if you
          wish to be treated as a Retail Client)
        </b-form-radio>
        <b-form-radio value="EligibleCounterparty">
          We request to be re-classified as an Eligible Counterparty instead of a Professional Client
          (decreasing the level of protection)
        </b-form-radio>
      </b-form-radio-group>
    </b-form-group>

    <div class="border rounded p-1">
      <p class="mb-50">
        <strong>Requirements for reclassification from a Retail Client to a Professional Client</strong><br />
        <small class="text-muted">
          Should you wish to be reclassified as Professional Client then you must meet at least two (2)
          of the following criteria:
        </small>
      </p>
      <b-form-checkbox v-model="section.criteria.transactions" class="mb-25">
        You have made transactions of a significant size in the relevant market 10 times per quarter
        in average during the four preceding quarters
      </b-form-checkbox>
      <b-form-checkbox v-model="section.criteria.portfolio" class="mb-25">
        The size of your financial portfolio (cash deposits and financial instruments) exceeds an
        amount equivalent to EUR 500,000
      </b-form-checkbox>
      <b-form-checkbox v-model="section.criteria.professional">
        You work, or have worked, in the financial sector for at least one year in a professional
        position which requires knowledge of the relevant transactions and investment services
      </b-form-checkbox>
    </div>

    <p class="text-muted small mt-1 mb-0">
      The re-categorisation request is signed on the final "Review &amp; sign" step.
    </p>
  </fieldset>
</template>

<script>
// Section F — Re-categorisation of Client Classification (choice + criteria). The
// re-categorisation name and signature are collected on the review step.
export default {
  name: "SectionRecategorisation",

  props: {
    section: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
  },
};
</script>
